import React, { useEffect, useRef, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { goToInvalid } from "utils/invalidRoute";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  addNotification,
  updateTokenExpiredStatus,
  updateTokenStatus,
  updateUserData,
  useUserData,
} from "store/slices/authSlice";
import expiryDateValidation, {
  cardToShortname,
  checkBankManualFormOrPlaid,
  checkDefaultMethodExist,
  checkNewPaymentDetails,
  checkOldPaymentDetails,
  clearSlice,
  downloadPdfFromApi,
  formatCurrency,
  formatExpirationDate,
  getBankName,
  getCardType,
  getGeneralDetailMarkers,
  getMethod,
  getMethodCode,
  getOperatingSystem,
  validateCard,
} from "utils/HelperFunctions";
import logo from "icons/smallLogo.svg";
import ScannerImg from "../../icons/bi_qr-code.png";
import Footer from "components/layout/footer";
import PaymentMethodsComponent from "components/paymentMethod/PaymentMethodsComponent";
import { CardIcon } from "icons/payments/Card";
import { BankIconSm } from "icons/payments/BankIconSm";
import WireTransferIcon from "icons/payments/WireTransferIcon";
import { PaypalIcon } from "icons/dashboard/paypal";
import { CashAppIcon } from "icons/dashboard/cashAppIcon";
import { valuesProps } from "types/paymentMethods";
import moment from "moment";
import PaymentProcessStep2 from "pages/payments/PaymentProcessStep2";
import { AddCircleIconBlue } from "utils/icon";
import Button from "components/form/Button";
import InvoiceSuccess from "components/actionCenter/InvoiceSuccess";
import InvoiceFail from "components/actionCenter/InvoiceFail";
import InvoicePreview from "components/actionCenter/InvoicePreview";
import Drawer from "components/ui-component/SideDrawer";
import {
  invoiceDetailsGet,
  invoiceDetailsSend,
  invoicePayment,
  invoiceUpdate,
} from "store/slices/subscriptionSlice";
import DisclosureInitial from "components/makePayment/DisclosureInitial";
import {
  useLeadData,
  usePortalSettingsData,
  usePortalVanityUrl,
} from "store/slices/dashboardSlice";
import AmazonPay from "icons/dashboard/AmazonPay";
import DisclosureFinal from "components/makePayment/DisclosureFinal";
import {
  addCard,
  oldPaymentMethodsGet,
  useBankData,
  useCardData,
  useHasLoadedPaymentMethods,
  useOldWalletData,
} from "store/slices/paymentMethodSlice";
import {
  convFeeGet,
  createPaypalPaymentToken,
  createPaypalToken,
  duplicatePaymentGet,
  makeGooglePay,
  markIncompletePayment,
  paymentReceiptDownloadPdf,
  resetCheckDuplicatePayment,
  resetDuplicateOrder,
  setIsPaymentProcessing,
  storePayPalOrder,
  updateLogoAndFavicon,
  updatePaymentPermission,
  verifyPaymentsViaStax,
  verifyWalletPay,
  wirePaymentProcess,
} from "store/slices/paymentsSlice";
import {
  FormRef,
  PaymentGateway,
  PaymentMethodList,
  SettingsValue,
} from "types/payments";
import { decode } from "utils/HelperFunctions";
import WirePaymentSuccess from "components/actionCenter/WirePaymentSuccess";
import { BASE_URL } from "store/api/constApi";
import { useMediaQuery } from "react-responsive";
import { useNavigationGuard } from "hooks/useNavigationGuard";
import { useDefaultPaymentMethodView } from "hooks/useDefaultPaymentMethodView";
import {
  decodeAndValidatePublicLink,
  isInvalidPublicLinkResult,
} from "utils/publicLinkValidation";
import {
  onSetFinalDisclosureLoading,
  onSetShowDisclosure,
  useIsLogin,
  useShowFinalDisclosure,
} from "store/slices/commonSlice";
import { initialValues } from "utils/countryAddressList";
import CustomModal from "components/ui-component/CustomModal";
import { RootState } from "store/store";
import {
  VerifyStaxCardPaymentParams,
  VerifyStripeCardPaymentParams,
} from "types/agreement";
import InvoiceCanceled from "components/actionCenter/InvoiceCanceled";
import { TOKEN_STORAGE_KEY } from "store/api/axiosApi";
import { TestIdScope, useTestAttrsFactory } from "utils/testid";

const InvoiceContent = () => {
  const testAttrs = useTestAttrsFactory();
  const isLessThan590 = useMediaQuery({ query: "(max-width:590px)" });
  const showFinalDisclosure = useShowFinalDisclosure();
  const [showDetails, setShowDetails] = useState<boolean>(true);
  const [isStaxPayPalLoading, setIsStaxPayPalLoading] =
    useState<boolean>(false);
  const [invoiceData, setInvoiceData] = useState<any>({});
  const [ORCode, setQRCode] = useState<string | null>(null);
  const isLogin = useIsLogin();
  const [selectedMethod, setSelectedMethod] = useState<
    "Card" | "Bank" | "PayPal" | "Cash App Pay" | string
  >("Card");

  const portalSettings = usePortalSettingsData();
  const vanityUrl = usePortalVanityUrl();
  const [initialDisclosureAccept, setInitialDisclosureAccept] =
    useState<boolean>(false);
  const [isAddNewCard, setIsAddNewCard] = useState<boolean>(false);
  const [showButtons, setShowButtons] = useState<boolean>(true);
  const [values, setValues] = useState<valuesProps>(initialValues);
  const [invoiceSlug, setInvoiceSlug] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [cardNumber, setcardNumber] = useState<string>("");
  const [iconType, setIconType] = useState<string>("");
  const [selectedState, setSelectedState] = useState<any>(undefined);
  const [isDateErr, setIsDateErr] = useState<boolean>(false);
  const [bankName, setBankName] = useState<any>("");
  const [bank, setBank] = useState<any>("");
  const [errMsg, setErrMsg] = useState<string | undefined>(undefined);
  const [isRingLoading, setIsRingLoading] = useState<boolean>(false);
  const [numberNotmatchedError, setnumberNotmatchedError] =
    useState<boolean>(false);
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [isErr, setIsErr] = useState(-1);
  const [cardErrMsg, setCardErrMsg] = useState("");
  const [savedCardsEmail, setSavedCardsEmail] = useState<string>("");
  const [isGoogleLoading, setIsGoogleLoading] = useState<boolean>(false);
  const [amount, setAmount] = useState(0);
  const [amountDisplay, setAmountDisplay] = useState(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isBTNLoading, setIsBTNLoading] = useState<boolean>(false);
  const [isScreenLoading, setIsScreenLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const {
    conFee,
    isFeeLoading,
    payPalOrder,
    checkedDuplicatePayment,
    duplicateOrdersCount,
    isDuplicateOrders,
    isPaymentProcessing,
  } = useAppSelector((state: RootState) => state.payment);
  const abortControllerRef = useRef<AbortController | null>(null);
  const { id: actionId } = useParams();
  const userData = useUserData();
  const accountData = userData?.data?.accountData;
  const cardList = useCardData();
  const bankList = useBankData();
  const oldWalletData = useOldWalletData();
  const accountLeadData = useLeadData();
  const [emailInput, setEmailInput] = useState<string>("");
  const [paymentSuccess, setPaymentSuccess] = useState<string | null>(null);
  const [id, setId] = useState<string | undefined>(undefined);
  const [isPreview, setIsPreview] = useState<boolean>(false);
  const [isEmailLoading, setIsEmailLoading] = useState<boolean>(false);
  const [isDownloadLoading, setIsDownloadLoading] = useState<boolean>(false);
  const [failedReason, setFailedReason] = useState<string | null>(null);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const [tokenData, setTokenData] = useState<any>(null);
  const [isWirePayment, setIsWirePayment] = useState<boolean>(false);
  const [isManualForm, setIsManualForm] = useState<boolean>(true);
  const stepperAnchorRef = useRef<HTMLDivElement>(null);
  const [wireDetails, setWireDetails] = useState({
    email: "",
    bank: "",
    routing: "",
    account: "",
    swift: "",
    dueDate: "",
  });
  const [paymentLogo, setPaymentLogo] = useState<any>(logo);
  const { brandColor, isDark } = useAppSelector(
    (state: RootState) => state.dashboard
  );

  const defaultPaymentMethodList: PaymentMethodList[] = [
    {
      name: "Card",
      icon: <CardIcon />,
    },
    {
      name: "Bank",
      icon: <BankIconSm />,
    },
  ];
  const [paymentMethodList, setPaymentMethodList] = useState<
    PaymentMethodList[]
  >(defaultPaymentMethodList);
  const { paymentPermission } = useAppSelector(
    (state: RootState) => state.payment
  );
  const hasLoadedPaymentMethods = useHasLoadedPaymentMethods();
  const initialState = {
    filterParamValue: "",
    filterParam: "search",
    page: 1,
    state: "AL",
    country: "US",
    isrecurring: "oneTime",
    agreementType: "new",
    type: "Amount",
    amount: "0.00",
    new_offer_type: "Amount",
    paymentPlan: { start_date: moment().format("MM/DD/YYYY") },
    selectedCard: {},
    selectedBank: {},
  };
  const [dataPayment, setDataPayment] = useState<any>(initialState);
  // refs for payment
  const cardRef = useRef<FormRef>(null);
  const cashAppRef = useRef<FormRef>(null);
  const bankRef = useRef<FormRef>(null);
  const amazonRef = useRef<FormRef>(null);

  useDefaultPaymentMethodView({
    cardList,
    bankList,
    walletList: oldWalletData,
    paymentMethodList,
    paymentPermission,
    isLogin,
    hasLoadedPaymentMethods,
    setShowSavedMethods: setIsAddNewCard,
    setDataPayment,
    selectedMethod,
    setSelectedMethod,
  });

  useEffect(() => {
    if (actionId) {
      setInvoiceSlug(actionId);
    }
  }, [actionId]);

  useEffect(() => {
    if (isLogin && invoiceData && userData) {
      const accounts_id = invoiceData?.accounts_id;
      const id = userData?.data?.accountData?.id;

      if (id && accounts_id && id !== accounts_id) {
        clearSlice(dispatch);
        localStorage.removeItem(TOKEN_STORAGE_KEY);
        dispatch(updateTokenExpiredStatus(false));
        dispatch(updateTokenStatus(false));
        localStorage.clear();
        window.location.reload();
      }
    }
  }, [invoiceData, isLogin, userData]);

  const getInvoiceData = async () => {
    const decodedLink = decodeAndValidatePublicLink(actionId, "inv_");
    if (!decodedLink) {
      goToInvalid(navigate, "link");
      return;
    }

    try {
      let payload = { slug: actionId, clusterid: decodedLink.clusterId };
      let res: any = await dispatch(invoiceDetailsGet(payload)).unwrap();

      if (isInvalidPublicLinkResult(res)) {
        goToInvalid(navigate, "link");
        return;
      }

      if (res?.body?.success) {
        let {
          invoiceData,
          qrcode,
          customerData,
          companyLogoDetails,
          paymentPermission,
        } = res?.body?.data;
        setInvoiceData(invoiceData);
        setAmount(invoiceData?.total_amount || 0);
        setQRCode(qrcode || null);
        dispatch(updatePaymentPermission(paymentPermission));
        dispatch(
          updateUserData({
            ...userData?.data?.accountData,
            ...customerData,
          })
        );
        setPaymentLogo(companyLogoDetails?.logo);
        dispatch(updateLogoAndFavicon(companyLogoDetails));

        if (
          invoiceData?.status?.toLowerCase() === "opened" ||
          invoiceData?.status?.toLowerCase() === "open" ||
          invoiceData?.status?.toLowerCase() === "pending"
        ) {
          await dispatch(
            addNotification({
              initiated_by: "contact",
              event_type: "invoice",
              userid: customerData?.leadData?.user_id,
              email: "",
              event_status: "clicked",
              activity_type: "invoice_activity",
              clusterid: decodedLink.clusterId,
              communication_status: "",
              accounts_id: invoiceData?.accounts_id,
              payment_amount: invoiceData?.total_amount,
              invoice_id: decodedLink.recordId,
            })
          );
        } else if (invoiceData?.status === "CANCELLED") {
          setPaymentSuccess("cancelled");
          setAmountDisplay(invoiceData?.total_amount || 0);
          setEmail(invoiceData?.bemail_address);
        } else {
          setPaymentSuccess("success");
          setAmountDisplay(invoiceData?.total_amount || 0);
          setEmail(invoiceData?.bemail_address);
          const paymentHistory = invoiceData?.paymentHistory;
          setOrderId(paymentHistory?.[0]?.id);
        }
      }
    } catch (error) {
      if (isInvalidPublicLinkResult(error)) {
        goToInvalid(navigate, "link");
        return;
      }
      console.log("getInvoiceData error =====", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getInvoiceData();
  }, [actionId]);

  const scrollToStepper = () => {
    if (stepperAnchorRef.current) {
      stepperAnchorRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      return;
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    if (showFinalDisclosure) {
      requestAnimationFrame(() => {
        scrollToStepper();
      });
    }
  }, [showFinalDisclosure]);

  useEffect(() => {
    if (!actionId) return;
    const requestOptions = {
      method: "GET",
      redirect: "follow",
    };

    fetch(
      `${BASE_URL}/portal/get-payment-status?slug=${actionId}&type=invoice`,
      requestOptions as any
    )
      .then((response) =>
        handleStreamResponse(response, (res: any) => {
          const match = res.match(
            /"success":\s*(true|false).*?"status":"(.*?)".*?"conv_fee":"(.*?)".*?"invoice_slug":"(.*?)".*?"total_amount":"(.*?)"/
          );

          if (match) {
            if (match[1] === "true") {
              if (match[2] === "PAID") {
                setPaymentSuccess("success");
                if (match[5] && Number(match[5]) >= 0) {
                  setAmountDisplay(match[5]);
                }
                if (actionId !== match[4]) {
                  setInvoiceSlug(match[4]);
                }
              }
            }
          }
        })
      )
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  }, [actionId]);

  const handleStreamResponse = async (
    response: any,
    onSuccessCallback: any
  ) => {
    const reader = response.body.getReader();

    try {
      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          console.log("Stream finished.");
          break;
        }
        const chunk: any = new TextDecoder().decode(value);

        onSuccessCallback(chunk);
      }
    } catch (error) {
      console.error("Error reading the stream", error);
      // isConnectionClosed(true); // Assume the connection is closed on error
    }
  };

  // payment permission
  useEffect(() => {
    if (
      invoiceData &&
      invoiceData?.payment_method_options &&
      invoiceData?.payment_method_options.trim() !== ""
    ) {
      let methodArr = invoiceData?.payment_method_options?.split("-");
      let updatedArr: any = [];
      let card = false;

      const isSubscription =
        invoiceData?.subscriptionDetails &&
        Object.keys(invoiceData?.subscriptionDetails)?.length > 0;

      methodArr.forEach((item: any) => {
        if (
          item?.toLowerCase() === "ach" &&
          paymentPermission &&
          paymentPermission?.ach_ext_availability === SettingsValue.YES
        ) {
          updatedArr.push({ name: "Bank", icon: <BankIconSm /> });
        } else if (
          item?.toLowerCase() === "pp" &&
          paymentPermission &&
          !isSubscription &&
          paymentPermission?.pp_ext_availability === SettingsValue.YES
        ) {
          updatedArr.push({ name: "PayPal", icon: <PaypalIcon /> });
        } else if (
          item?.toLowerCase() === "cc" &&
          paymentPermission &&
          paymentPermission?.cc_ext_availability === SettingsValue.YES
        ) {
          card = true;
          updatedArr.push({ name: "Card", icon: <CardIcon /> });
        } else if (
          (item?.toLowerCase() === "wto" || item?.toLowerCase() === "wt") &&
          paymentPermission &&
          paymentPermission?.wt_ext_availability === SettingsValue.YES
        ) {
          updatedArr.push({ name: "Wire", icon: <WireTransferIcon /> });
        } else if (
          item?.toLowerCase() === "capp" &&
          paymentPermission &&
          paymentPermission?.capp_ext_availability === SettingsValue.YES
        ) {
          updatedArr.push({ name: "Cash App Pay", icon: <CashAppIcon /> });
        } else if (
          item?.toLowerCase() === "amzp" &&
          paymentPermission &&
          paymentPermission?.amzp_ext_availability === SettingsValue.YES
        ) {
          updatedArr.push({ name: "Amazon Pay", icon: <AmazonPay /> });
        }
      });
      setPaymentMethodList(updatedArr);
      if (!card) {
        setSelectedMethod(updatedArr?.[0]?.name);
      }
    }
  }, [invoiceData, paymentPermission]);

  const findBankByRoutingNumber = async (routingNumber: string) => {
    setIsRingLoading(true);
    try {
      let bankObj = await getBankName(routingNumber);
      if (bankObj?.type === "success") {
        setBankName(bankObj?.bank_name);
        setBank(bankObj?.bank_name);
      } else {
        setErrMsg("Invalid routing number");
        setIsRingLoading(false);
      }
    } catch (error) {
      console.log("error =====", error);
      setErrMsg("Invalid routing number");
      setIsRingLoading(false);
    } finally {
      setIsRingLoading(false);
    }
  };

  const handleChangeCard = (e: any, name: string) => {
    dispatch(setIsPaymentProcessing(true));
    let value = { ...values };
    if (name === "x_card_num") {
      let icon = getCardType(e.target.value) || iconType;
      if (icon === "amex") {
        if (e.target.value.length < 18) {
          const cardNumber = e.target.value.replace(/\s/g, "");
          const formattedCardNumber = cardNumber
            .replace(/\D/g, "")
            .replace(/(\d{4})(\d{6})(\d{5})/, "$1 $2 $3");
          setcardNumber(formattedCardNumber);
          value = { ...values, [name]: e.target.value };
          // setValues({ ...values, [name]: e.target.value });
        }
      } else {
        if (e.target.value.length < 20) {
          const cardNumber = e.target.value.replace(/\s/g, "");
          const formattedCardNumber = cardNumber
            .replace(/\D/g, "")
            .replace(/(\d{4})(?=\d)/g, "$1 ");
          setcardNumber(formattedCardNumber);
          value = { ...values, [name]: e.target.value };

          // setValues({ ...values, [name]: e.target.value });
        }
      }
    } else if (name === "x_card_code") {
      if (iconType === "amex") {
        if (e.target.value.length < 5) {
          value = { ...values, [name]: e?.target?.value };
        }
      } else {
        console.log("called");
        if (e.target.value.length < 4) {
          value = { ...values, [name]: e?.target?.value };
        }
      }
    } else if (name === "x_exp_date") {
      const inputValue = e.target.value;
      setIsDateErr(false);
      if (inputValue?.length < 6) {
        const isValidDate: any = expiryDateValidation(inputValue);
        const formattedDate = formatExpirationDate(inputValue);
        value = { ...value, [name]: formattedDate };
        !isValidDate?.isValid && inputValue?.length === 5 && setIsDateErr(true);
      }
    } else if (name === "x_country") {
      value = { ...value, [name]: e?.value };
    } else if (name === "x_state") {
      value = { ...value, [name]: e?.name };
    } else {
      value = { ...value, [name]: e.target.value };
    }
    setValues(value);
  };

  const handleChangeBank = (e: any, name: string) => {
    dispatch(setIsPaymentProcessing(true));
    if (name === "routing_number") {
      if (e?.target?.value?.length < 10) {
        setValues({ ...values, [name]: e.target.value });
        setBankName("");
        setBank("");
        setErrMsg(undefined);
        if (e?.target?.value?.length === 9) {
          findBankByRoutingNumber(e?.target?.value);
        }
      }
    } else if (name === "r_account_number") {
      setnumberNotmatchedError(false);
      setValues({ ...values, [name]: e?.target.value });
      if (values?.account_number?.length === e?.target?.value?.length) {
        setnumberNotmatchedError(values?.account_number !== e?.target?.value);
      }
    } else {
      setValues({ ...values, [name]: e?.target?.value });
    }
  };

  useEffect(() => {
    if (!cardNumber) {
      setIconType("");
      setValues({ ...values, card_type: "" });
      return;
    } else {
      setIconType(getCardType(cardNumber));
      setValues({ ...values, card_type: getCardType(cardNumber) });
    }
  }, [cardNumber]);

  useEffect(() => {
    if (isAddNewCard) {
      let response = checkOldPaymentDetails({ dataPayment });
      setIsDisabled(response);
    } else {
      let response = checkNewPaymentDetails({
        values,
        cc_billing_address: portalSettings?.cc_billing_address,
        cc_billing_addr_mandatory: portalSettings?.cc_billing_addr_mandatory,
        selectedMethod,
        email,
        isErr,
        errMsg,
      });
      setIsDisabled(response);
    }
  }, [selectedMethod, values, email, isAddNewCard, dataPayment, isErr, errMsg]);

  const handleBackToStart = () => {
    setValues(initialValues);
    setErrMsg(undefined);
    setIconType("");
    setCardErrMsg("");
    setPaymentSuccess(null);
    setEmailInput("");
    setEmail("");
    setFailedReason("");
    setIsPreview(false);
    setId("");
    setcardNumber("");
    setIsAddNewCard(false);
    dispatch(onSetShowDisclosure(false));
    dispatch(resetDuplicateOrder());
    dispatch(resetCheckDuplicatePayment());
    dispatch(onSetFinalDisclosureLoading(false));
    setInitialDisclosureAccept(false);
  };

  const { allowPendingNavigation, cancelPendingNavigation } =
    useNavigationGuard({
      shouldBlock: () => isPaymentProcessing,
      onNavigationAttempt: () => setShowModal(true),
    });

  const handleConfirmLeave = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    dispatch(setIsPaymentProcessing(false));
    setShowModal(false);
    setTimeout(() => allowPendingNavigation(), 250);
  };

  const handleCancelLeave = () => {
    setShowModal(false);
    cancelPendingNavigation();
  };

  useEffect(() => {
    dispatch(
      setIsPaymentProcessing(isBTNLoading || isGoogleLoading || isScreenLoading)
    );
    return () => {
      dispatch(setIsPaymentProcessing(false));
    };
  }, [dispatch, isBTNLoading, isGoogleLoading, isScreenLoading]);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (isPaymentProcessing) {
        e.preventDefault();
        e.returnValue = "";
        return "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isPaymentProcessing]);

  const handleCreateNewCard = async (payload: any) => {
    const payloads = {
      x_card_num: payload?.x_card_num?.replaceAll(" ", ""),
      x_exp_date: payload?.x_exp_date,
      x_card_code: payload?.x_card_code,
      choldername: payload?.choldername,
      x_payment_method: payload?.x_payment_method,
      x_city: payload?.x_city,
      x_address: payload?.x_address,
      address2: payload?.address2,
      x_zip: payload?.x_zip,
      x_state: payload?.x_state,
      x_country: payload?.x_country,
      routing_number: payload?.routing_number,
      account_number: payload?.account_number,
      bank_name: payload?.bankName,
      swift_code: payload?.swift_code,
      card_funding_type: payload?.card_funding_type,
      default: "Y",
      default_profile: "N",
      // default: checkDefaultMethodExist(cardList, bankList, oldWalletData),
      // default_profile: checkDefaultMethodExist(
      //   cardList,
      //   bankList,
      //   oldWalletData
      // ),
      cluster_id: invoiceData?.clusterid,
      accountid: accountData?.accountid,
      x_first_name: accountData?.first_name,
      x_last_name: accountData?.last_name,
      x_phone: accountData?.phone || "",
      x_email: accountData?.email || "",
      lead_id: invoiceData?.lead_id || "",
      gateway_id:
        selectedMethod === "Card"
          ? paymentPermission?.cc_gateway
          : paymentPermission?.ach_gateway || "",
      gateway_name:
        selectedMethod === "Card"
          ? paymentPermission?.cc_gateway_name?.name
          : paymentPermission?.ach_gateway_name?.name || "",
      account_holder_name: values?.choldername ?? "",
      card_type: payload?.iconType,
      accounts_id: accountData?.id,
    };

    try {
      const res: any = await dispatch(addCard(payloads)).unwrap();
      if (res?.body?.success) {
        await handlePayment({
          ...payload,
          cc_token: res?.body?.data?.paymentMethod.cc_token,
          cc_token2: res?.body?.data?.paymentMethod.cc_token2,
          stripe_token: res?.body?.data?.paymentMethod.cc_token,
        });
      } else {
        setIsErr(4);
        setCardErrMsg(
          "An error occurred while processing your payment. Try again later or with a different payment method."
        );
      }
    } catch (error: any) {
      setIsErr(4);
      setCardErrMsg(
        "An error occurred while processing your payment. Try again later or with a different payment method."
      );
    }
  };

  const onOldCardDataGet = async () => {
    try {
      let payload = {
        accountid: accountData?.accountid,
        accounts_id: userData?.data?.accountData?.id,
        cluster_id: invoiceData?.clusterid,
      };
      await dispatch(oldPaymentMethodsGet(payload)).unwrap();
    } catch (error: any) {
      console.log("old card data get erro:-->", error?.message);
    }
  };

  useEffect(() => {
    if (isLogin && invoiceData) {
      onOldCardDataGet();
    }
  }, [isLogin, invoiceData]);

  const changeUrl = (result: any) => {
    if (result?.success && result?.invoiceSlug) {
      if (result?.invoiceSlug !== actionId) {
        setInvoiceSlug(result?.invoiceSlug);
        navigate(`/invoice/${result?.invoiceSlug}`);
      }
    }
  };

  const paymentViaWire = async () => {
    dispatch(setIsPaymentProcessing(true));
    try {
      let payload = {
        slug: actionId || "",
        payment_gateway_id: "",
        amount: amount,
        clusterid: invoiceData?.clusterid,
        x_method: "WTO",
        lead_id: invoiceData?.lead_id,
        email: accountData?.email,
        accountid: accountData?.accountid,
        isInvoice: true,
        clientInvoiceId: invoiceData?.id,
        isScheduleOnetime:
          invoiceData?.subscriptionDetails &&
          Object.keys(invoiceData?.subscriptionDetails)?.length > 0
            ? true
            : false,
        schedule_id: invoiceData?.subscription_id,
        description: "Online Payment",
        payment_note: "Invoice",
        ivr_type: "CUST_PRTL",
      };
      let res: any = await dispatch(wirePaymentProcess(payload)).unwrap();
      if (res.body.success) {
        setWireDetails({
          email: res?.body?.data?.email || "",
          bank: res?.body?.data?.bank_name || "",
          routing: res?.body?.data?.routing_number || "",
          account: res?.body?.data?.account_number || "",
          swift: res?.body?.data?.swift_code || "",
          dueDate:
            moment(
              moment().add(res?.body?.data?.wire_deadline || 0, "days")
            ).format("MM/DD/YYYY") || "",
        });
        setIsWirePayment(true);
        const { data } = res?.body;
        let values = {
          invoice_id: invoiceData?.id,
          email: data?.email,
          order_id: data?.invoice_id,
          clusterid: invoiceData?.clusterid,
        };
        let invoiceResult = await updateInvoice(values, true, amount);
        let pay = {
          invoice_id: res?.body?.data?.invoice_id,
          emails: res?.body?.data?.email,
          bank_name: res?.body?.data?.bank_name,
          routing_number: res?.body?.data?.routing_number,
          account_number: res?.body?.data?.account_number,
          swift_code: res?.body?.data?.swift_code,
          invoice_slug: invoiceResult?.invoiceSlug || "",
        };
        await sendEmail(pay);
        changeUrl(invoiceResult);
      } else {
        setFailedReason(res?.body?.data?.msg);
        let values = {
          invoice_id: invoiceData?.id,
          email: accountData?.email,
          clusterid: invoiceData?.clusterid,
        };
        await updateInvoice(values, false, amount);
      }

      dispatch(setIsPaymentProcessing(false));
    } catch (error) {
      console.log(" paymentViaWire error=====", error);
    } finally {
      dispatch(setIsPaymentProcessing(false));
      setIsBTNLoading(false);
    }
  };

  const updateInvoice = async (
    payload: any,
    paymentSuccess: boolean = false,
    amount: any = 0
  ) => {
    try {
      let slug = decode(actionId || "")?.split("_");
      let res: any = await dispatch(invoiceUpdate(payload)).unwrap();
      if (res?.body?.success && paymentSuccess) {
        setPaymentSuccess("success");
        setOrderId(payload?.order_id);
        await dispatch(
          addNotification({
            initiated_by: "contact",
            event_type: "invoice",
            userid: userData?.data?.accountData?.leadData?.user_id,
            email: "",
            event_status: "paid",
            activity_type: "invoice_activity",
            clusterid: slug[1],
            communication_status: "",
            accounts_id: userData?.data?.accountData?.id,
            payment_amount: amount,
            invoice_id: res?.body?.data?.invoiceId,
            comments: `Invoice ${res?.body?.data?.invoice_number} was paid.`,
          })
        );

        await dispatch(
          addNotification({
            initiated_by: "contact",
            event_type: "invoice",
            userid: userData?.data?.accountData?.leadData?.user_id,
            email: "",
            event_status: "succeeded",
            activity_type: "payment_activity",
            clusterid: slug[1],
            communication_status: "",
            accounts_id: userData?.data?.accountData?.id,
            payment_amount: amount,
            order_id: payload?.order_id,
            invoice_id: res?.body?.data?.invoiceId,
            comments: `Payment of ${formatCurrency(amount || 0)} for invoice ${res?.body?.data?.invoice_number} succeeded`,
          })
        );

        await dispatch(
          addNotification({
            initiated_by: "contact",
            event_type: "invoice",
            userid: userData?.data?.accountData?.leadData?.user_id,
            email: "",
            event_status: "succeeded",
            activity_type: "invoice_event",
            clusterid: slug[1],
            communication_status: "",
            accounts_id: userData?.data?.accountData?.id,
            payment_amount: amount,
            order_id: payload?.order_id,
            invoice_id: res?.body?.data?.invoiceId,
            comments: `Payment of ${formatCurrency(amount || 0)} was successfully applied`,
          })
        );

        return { success: true, invoiceSlug: res?.body?.data?.invoice_slug };
      } else {
        await dispatch(
          addNotification({
            initiated_by: "contact",
            event_type: "invoice",
            userid: userData?.data?.accountData?.leadData?.user_id,
            email: "",
            event_status: "failed",
            activity_type: "payment_activity",
            clusterid: slug[1],
            communication_status: "",
            accounts_id: userData?.data?.accountData?.id,
            payment_amount: amount,
            order_id: payload?.order_id,
            invoice_id: payload?.invoice_id,
            comments: `Payment of ${formatCurrency(amount || 0)} for invoice ${payload?.invoice_id} failed`,
          })
        );

        await dispatch(
          addNotification({
            initiated_by: "contact",
            event_type: "invoice",
            userid: userData?.data?.accountData?.leadData?.user_id,
            email: "",
            event_status: "failed",
            activity_type: "invoice_event",
            clusterid: slug[1],
            communication_status: "",
            accounts_id: userData?.data?.accountData?.id,
            payment_amount: amount,
            order_id: payload?.order_id,
            invoice_id: payload?.invoice_id,
            comments: `Payment for the invoice failed`,
          })
        );
        setPaymentSuccess("fail");
      }
      return { success: false };
    } catch (error) {
      setPaymentSuccess("fail");
      console.log("updateInvoice error =====", error);
    } finally {
      dispatch(setIsPaymentProcessing(false));
      setIsGoogleLoading(false);
      setIsBTNLoading(false);
      setIsScreenLoading(false);
      dispatch(onSetFinalDisclosureLoading(false));
      dispatch(onSetShowDisclosure(false));
    }
  };

  useEffect(() => {
    if (paymentSuccess !== null) {
      dispatch(setIsPaymentProcessing(false));
    }
  }, [paymentSuccess]);

  const processPaymentLink = async (values: any) => {
    dispatch(setIsPaymentProcessing(true));
    const { lead_owners, balance, first_name, last_name, accountid } =
      accountData || {};

    const {
      x_payment_method,
      x_city,
      x_address,
      address2,
      x_zip,
      x_state,
      x_country,
      email,
      iconType,
      x_card_num,
      x_card_code,
      x_exp_date,
      choldername,
      routing_number,
      account_number,
      bankName,
      bank,
      cc_token,
      cc_token2,
      stripe_token,
      cppid,
      pc_atid,
    } = values;

    const payload = {
      slug: actionId || "",
      lead_id: invoiceData?.lead_id,
      cluster_id: invoiceData?.clusterid,
      // agent: lead_owners,
      balance,
      lead_owner: lead_owners,
      x_payment_method,
      city: x_city,
      address1: x_address,
      address2: address2,
      zipcode: x_zip,
      state: x_state,
      country: x_country,
      first_name,
      last_name,
      accountid,
      amount: amount,
      email,
      use_old_card: "1",
      description: "Online Payment",
      payment_note: "Invoice",
      customer_device: getOperatingSystem(),
      card_type: iconType ? iconType : "",
      old_cardnumber: x_card_num ? x_card_num?.replaceAll(" ", "") : "",
      old_cvv: x_card_code ? x_card_code : "",
      old_expiry: x_exp_date ? x_exp_date : "",
      old_4digit: x_card_num ? x_card_num?.slice(-4) : "",
      old_type: iconType ? iconType : "",
      old_zip: x_zip ? x_zip : "",
      cvv: x_card_code ? x_card_code : "",
      cexpiry: x_exp_date ? x_exp_date : "",
      ccardnumber: x_card_num ? x_card_num?.replaceAll(" ", "") : "",
      choldername: choldername ? choldername : "",
      aholdername: choldername ? choldername : "",
      routing_number: routing_number ? routing_number : "",
      account_number: account_number ? account_number : "",
      bank_name: bankName ? bankName : "",
      bank_address: bank ? bank : "",
      cc_token: cc_token ? cc_token : "",
      cc_token2: cc_token2 ? cc_token2 : "",
      stripe_token: stripe_token ? stripe_token : "",
      isInvoice: true,
      clientInvoiceId: invoiceData?.id,
      cppid,
      pc_atid,
      custom_conv:
        invoiceData?.custom_conv === SettingsValue.YES ? "on" : "off",
    };

    try {
      const res: any = await dispatch(invoicePayment(payload)).unwrap();
      if (res?.body?.success) {
        const { data } = res?.body;
        setAmountDisplay(parseFloat(data?.total_amount));
        let payload = {
          invoice_id: invoiceData?.id,
          email: data?.email,
          order_id: data?.invoice_id,
          clusterid: invoiceData?.clusterid,
        };
        let invoiceResult = await updateInvoice(payload, true, amount);
        let pay = {
          invoice_id: data?.invoice_id,
          emails: data?.email,
          invoice_slug: invoiceResult?.invoiceSlug || "",
        };
        await sendEmail(pay);
        changeUrl(invoiceResult);
      } else {
        let payload = {
          invoice_id: invoiceData?.id,
          email: email,
          clusterid: invoiceData?.clusterid,
        };
        await updateInvoice(payload, false, amount);
        setFailedReason(res?.body?.data?.msg);
      }
      dispatch(setIsPaymentProcessing(false));
    } catch (error: any) {
      let payload = {
        invoice_id: invoiceData?.id,
        email: email,
        clusterid: invoiceData?.clusterid,
      };
      await updateInvoice(payload, false, amount);
      console.error("Payment processing error:", error);
    } finally {
      dispatch(setIsPaymentProcessing(false));
    }
  };

  const handlePayment = async (payload: any) => {
    if (selectedMethod === "Wire") {
      await paymentViaWire();
    } else {
      await processPaymentLink(payload);
    }
  };

  const checkPastAmount = async (method?: string) => {
    try {
      let payload = {
        accounts_id: userData?.data?.accountData?.id,
        payment_method: method ? method : cardToShortname(selectedMethod),
        amount: amount,
      };
      let res: any = await dispatch(duplicatePaymentGet(payload)).unwrap();
      const { isDuplicateOrders, duplicateOrdersCount } = res?.body?.data;
      if (isDuplicateOrders && duplicateOrdersCount > 0) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.log("error =====", error);
    }
  };

  const handleCheckDisclosureAndDuplicate = async (method?: string) => {
    try {
      let moveAhead = !checkedDuplicatePayment
        ? await checkPastAmount(method)
        : true;
      if (!moveAhead) {
        dispatch(onSetFinalDisclosureLoading(false));
        setIsLoading(false);
        return false;
      } else {
        if (
          (portalSettings?.payment_agreement_opt === SettingsValue.CUSTOM ||
            portalSettings?.payment_agreement_opt === SettingsValue.DEFAULT) &&
          !showFinalDisclosure
        ) {
          setIsLoading(false);
          dispatch(resetDuplicateOrder());
          dispatch(onSetFinalDisclosureLoading(false));
          dispatch(onSetShowDisclosure(true));
        } else {
          dispatch(resetDuplicateOrder());
          dispatch(resetCheckDuplicatePayment());
          return true;
        }
      }
    } catch (error) {
      console.log("error =====", error);
    }
  };

  const handleSubmit = async () => {
    dispatch(setIsPaymentProcessing(true));
    setIsBTNLoading(true);
    let moveAhead = await handleCheckDisclosureAndDuplicate();
    if (!moveAhead) {
      setIsBTNLoading(false);
      return;
    }
    try {
      let payload;
      if (!isAddNewCard) {
        payload = {
          ...values,
          x_payment_method: getMethodCode(selectedMethod),
          email,
          iconType,
          bankName,
          bank,
        };
      } else {
        let method = "CC";

        if (
          dataPayment?.selectedBank &&
          Object.keys(dataPayment.selectedBank).length > 0
        ) {
          method = "ACH";
        }
        if (
          dataPayment?.selectedWallet &&
          Object.keys(dataPayment.selectedWallet).length > 0
        ) {
          method = "WT";
        }

        let selectedData;
        if (method === "CC") {
          selectedData = dataPayment?.selectedCard;
        } else if (method === "WT") {
          selectedData = dataPayment?.selectedWallet;
          method = selectedData?.payment_method;
        } else {
          selectedData = dataPayment?.selectedBank;
        }

        payload = {
          x_payment_method: method,
          email: savedCardsEmail,
          x_card_num: selectedData?.cc_4digit,
          x_card_code: selectedData?.cc_cvv,
          x_exp_date: selectedData?.cc_expiry,
          iconType: selectedData?.cc_type,
          routing_number: selectedData?.routing_number,
          account_number: selectedData?.account_number,
          cc_token: selectedData?.cc_token,
          cc_token2: selectedData?.cc_token2,
          stripe_token: selectedData?.cc_token,
          bankName: selectedData?.bank_name,
          x_city: selectedData?.billing_city,
          x_address: selectedData?.billing_address,
          address2: selectedData?.billing_address2,
          x_zip: selectedData?.billing_zip,
          x_state: selectedData?.billing_state,
          x_country: selectedData?.billing_country,
          choldername: selectedData?.account_name,
          cppid: selectedData?.id,
        };
      }
      if (
        !isAddNewCard &&
        (selectedMethod === "Card" ||
          selectedMethod === "Bank" ||
          selectedMethod === "Wallets")
      ) {
        await handleCreateNewCard(payload);
      } else {
        await handlePayment(payload);
      }
    } catch (error) {
      console.log("handleSubmit error =====", error);
    } finally {
      dispatch(setIsPaymentProcessing(false));
      dispatch(onSetFinalDisclosureLoading(false));
      dispatch(onSetShowDisclosure(false));
      dispatch(setIsPaymentProcessing(true));
    }
  };

  const handleGooglePay = async (tokenData: any, total_amount: any) => {
    dispatch(setIsPaymentProcessing(true));
    const { tokenizationData } = tokenData;
    let resp = JSON.parse(tokenizationData.token);
    try {
      setIsGoogleLoading(true);
      let payload = {
        slug: actionId || "",
        email: accountData?.email || "",
        stripe_token: resp?.id,
        phone_number: accountData?.phone,
        first_name: accountData?.first_name || "",
        last_name: accountData?.last_name || "",
        accountid: accountData?.accountid || "",
        total_amount: total_amount,
        clusterid: invoiceData?.clusterid,
        address1: resp?.card?.address_line1 || "",
        address2: resp?.card?.address_line2 || "",
        city: resp?.card?.address_city || "",
        state: resp?.card?.address_state || "",
        zip: resp?.card?.address_zip || "",
        country: resp?.card?.address_country || "",
        is_recurring: "N",
        lead_id: invoiceData?.lead_id,
        module: "process_paymnet",
        description: "Online Payment",
        payment_note: "Invoice",
        x_payment_method: "GP",
        currency: "usd",
        card_type: resp?.card?.brand || "",
        cc_last4: resp?.card?.last4 || "",
        cc_expiry: resp?.card?.exp_month + "/" + resp?.card?.exp_year || "",
        isInvoice: true,
        clientInvoiceId: invoiceData?.id,
        isScheduleOnetime:
          invoiceData?.subscriptionDetails &&
          Object.keys(invoiceData?.subscriptionDetails)?.length > 0
            ? true
            : false,
        schedule_id: invoiceData?.subscription_id,
        isPayForProduct: true,
        custom_conv:
          invoiceData?.custom_conv === SettingsValue.YES ? "on" : "off",
      };
      let res: any = await dispatch(makeGooglePay(payload));
      if (res?.payload?.body?.success) {
        setAmountDisplay(res?.payload?.body?.data?.total_amount);
        const { invoice_id } = res?.payload?.body?.data;
        let payload = {
          invoice_id: invoiceData?.id,
          email: accountData?.email,
          order_id: invoice_id,
          clusterid: invoiceData?.clusterid,
        };
        let invoiceResult = await updateInvoice(payload, true, total_amount);
        let pay = {
          invoice_id: invoice_id,
          emails: accountData?.email,
          invoice_slug: invoiceResult?.invoiceSlug || "",
        };
        await sendEmail(pay);
        changeUrl(invoiceResult);
      } else {
        let payload = {
          invoice_id: invoiceData?.id,
          email: accountData?.email,
          clusterid: invoiceData?.clusterid,
        };
        await updateInvoice(payload, false, total_amount);
        setFailedReason(res?.payload?.body?.data?.msg);
      }
      dispatch(setIsPaymentProcessing(false));
    } catch (error) {
      let payload = {
        invoice_id: invoiceData?.id,
        email: accountData?.email,
        clusterid: invoiceData?.clusterid,
      };
      await updateInvoice(payload, false, total_amount);
      console.log("handleGooglePay error =====", error);
    } finally {
      dispatch(setIsPaymentProcessing(false));
    }
  };

  const handleGooglePayPayment = async (tokenData: any, amount: any) => {
    dispatch(setIsPaymentProcessing(true));
    setIsGoogleLoading(true);
    let moveAhead = !checkedDuplicatePayment
      ? await checkPastAmount("GP")
      : true;
    try {
      if (!moveAhead) {
        dispatch(onSetFinalDisclosureLoading(false));
        setSelectedMethod("Google Pay");
        setIsGoogleLoading(false);
        setTokenData({ token: tokenData, total_amount: amount });
      } else {
        if (
          (portalSettings?.payment_agreement_opt === SettingsValue.CUSTOM ||
            portalSettings?.payment_agreement_opt === SettingsValue.DEFAULT) &&
          !showFinalDisclosure
        ) {
          setSelectedMethod("Google Pay");
          setTokenData({ token: tokenData, total_amount: amount });
          setIsGoogleLoading(false);
          dispatch(onSetFinalDisclosureLoading(false));
          dispatch(resetDuplicateOrder());
          dispatch(onSetShowDisclosure(true));
        } else {
          dispatch(resetDuplicateOrder());
          dispatch(resetCheckDuplicatePayment());
          await handleGooglePay(tokenData, amount);
        }
      }
    } catch (error) {
      console.log("handleGooglePayPayment error =====", error);
    }
  };

  const createPayPalIntent = async () => {
    try {
      const payload = {
        slug: actionId || "",
        isInvoice: true,
        is_recurring: "Y",
        phone_number: userData?.data?.accountData?.phone,
        first_name: userData?.data?.accountData?.first_name,
        last_name: userData?.data?.accountData?.last_name,
        accountid: userData?.data?.accountData?.accountid,
        amount: amount,
        agent: userData?.data?.accountData?.lead_owner,
        lead_owner: userData?.data?.accountData?.lead_owner,
        lead_id: accountLeadData?.lead_id ?? invoiceData?.lead_id,
        clusterid: decode(actionId || "")?.split("_")[1],
        success_url: `${
          window.location.href
        }?method=paypal&amount=${amount}&status=success&isRecurring=${true}`,
        cancel_url: `${
          window.location.href
        }?method=paypal&amount=${amount}&status=cancel&isRecurring=${true}`,
        start_date: new Date(),
      };
      let res: any = await dispatch(createPaypalToken(payload));
      if (res?.payload?.body?.success) {
        await dispatch(
          storePayPalOrder({
            url: res?.payload?.body?.result?.url,
            invoice_id: invoiceData?.id,
            token: res?.payload?.body?.result?.token,
            schedule_id: invoiceData?.subscription_id,
          })
        );
        let moveAhead = await handleCheckDisclosureAndDuplicate("PP");
        if (!moveAhead) {
          return res;
        }

        window.location.href = res?.payload?.body?.result?.url;
      } else {
        setFailedReason(res?.payload?.body?.data?.msg);
      }
    } catch (error) {
      console.log("createPayPalIntent error =====", error);
    }
  };

  const sendEmail = async ({
    emails,
    shouldSendAll,
    bank_name,
    routing_number,
    account_number,
    swift_code,
    invoice_slug = invoiceSlug,
  }: any) => {
    setIsEmailLoading(true);
    let email = Array.isArray(emails) ? emails?.[0] : emails;
    try {
      let payload: any = {
        invoice_slug: invoice_slug,
        clusterid: invoiceData?.clusterid,
        // accountid: accountData?.id,
        email: email,
        shouldSendAll: shouldSendAll,
        email_type: "invoice_receipt",
      };

      if (bank_name) {
        payload = {
          ...payload,
          bank_name: bank_name,
          routing_number: routing_number,
          account_number: account_number,
          swift_code: swift_code,
        };
      }
      await dispatch(invoiceDetailsSend(payload)).unwrap();
    } catch (error) {
      console.error("sendEmail", error);
    } finally {
      setIsEmailLoading(false);
    }
  };

  const handleDownloadPDF = async () => {
    let invoice_slug = invoiceData?.url_slug || actionId;
    let payload = {
      invoice_slug,
      lead_id: invoiceData?.lead_id,
      cluster_id: invoiceData?.clusterid,
      url: `${vanityUrl}invoice/${invoice_slug}`,
    };

    await downloadPdfFromApi(
      () => dispatch(paymentReceiptDownloadPdf(payload)).unwrap(),
      `Invoice - ${invoiceData?.invoice_number}.pdf`,
      setIsDownloadLoading
    );
  };

  const handleAccept = async () => {
    dispatch(setIsPaymentProcessing(true));
    await dispatch(onSetFinalDisclosureLoading(true));
    try {
      if (isAddNewCard) {
        await handleSubmit();
      } else {
        switch (selectedMethod) {
          case "Card":
            if (
              paymentPermission?.cc_gateway_name?.name ===
                PaymentGateway.STRIPE &&
              cardRef.current
            ) {
              await cardRef.current.callHandleClick();
            } else {
              await handleSubmit();
            }
            break;
          case "Amazon Pay":
            if (amazonRef.current) {
              await amazonRef.current.callHandleClick();
            } else {
              await handleSubmit();
            }
            break;
          case "Bank":
            let check = checkBankManualFormOrPlaid({
              manual_ach: portalSettings?.manual_ach,
              validate_bank_account: portalSettings?.validate_bank_account,
              isManualForm,
            });
            if (
              (paymentPermission?.ach_gateway_name?.name ===
                PaymentGateway.STRIPE ||
                check) &&
              bankRef.current
            ) {
              await bankRef.current.callHandleClick();
            } else {
              await handleSubmit();
            }
            break;
          case "Cash App Pay":
            if (cashAppRef.current) {
              await cashAppRef.current.callHandleClick();
            }
            break;
          case "Wire":
            await handleSubmit();
            break;
          case "PayPal":
            if (
              (portalSettings?.payment_agreement_opt === SettingsValue.CUSTOM ||
                portalSettings?.payment_agreement_opt ===
                  SettingsValue.DEFAULT) &&
              !showFinalDisclosure
            ) {
              dispatch(resetDuplicateOrder());
              dispatch(onSetFinalDisclosureLoading(false));
              dispatch(onSetShowDisclosure(true));
            } else {
              window.location.href = payPalOrder.url;
            }
            break;
          case "Google Pay":
            await handleGooglePayPayment(
              tokenData?.token,
              tokenData?.total_amount
            );
            break;
          default:
            console.log("selectedMethod =====", selectedMethod);
        }
      }
    } catch (error) {
      console.log("handleAccept error =====", error);
    } finally {
      dispatch(setIsPaymentProcessing(false));
    }
  };

  useEffect(() => {
    if (isAddNewCard) {
      setShowButtons(true);
    } else {
      if (selectedMethod === "Card") {
        if (
          paymentPermission?.cc_gateway_name?.name === PaymentGateway.STRIPE ||
          paymentPermission?.cc_gateway_name?.name === PaymentGateway.STAX
        ) {
          setShowButtons(false);
        } else {
          setShowButtons(true);
        }
      } else if (selectedMethod === "Bank") {
        let check = checkBankManualFormOrPlaid({
          manual_ach: portalSettings?.manual_ach,
          validate_bank_account: portalSettings?.validate_bank_account,
          isManualForm,
        });
        if (
          paymentPermission?.ach_gateway_name?.name === PaymentGateway.STRIPE ||
          paymentPermission?.ach_gateway_name?.name === PaymentGateway.STAX ||
          check
        ) {
          setShowButtons(false);
        } else {
          setShowButtons(true);
        }
      } else if (selectedMethod === "Wire") {
        setShowButtons(true);
      } else if (selectedMethod === "PayPal") {
        setShowButtons(false);
      } else if (selectedMethod === "Amazon Pay") {
        setShowButtons(false);
      } else if (selectedMethod === "Cash App Pay") {
        setShowButtons(false);
      }
    }
  }, [
    selectedMethod,
    isAddNewCard,
    paymentPermission,
    portalSettings,
    isManualForm,
  ]);

  useEffect(() => {
    const getConvFee = async () => {
      let slug = decode(actionId || "")?.split("_");
      const method = getMethod(isAddNewCard, dataPayment, selectedMethod);
      let paymentMethodId = "";
      if (
        method === "CC" &&
        paymentPermission?.cc_gateway_name?.name === PaymentGateway.STAX &&
        isAddNewCard
      ) {
        paymentMethodId = dataPayment?.selectedCard?.cc_token;
      } else if (
        method === "ACH" &&
        paymentPermission?.ach_gateway_name?.name === PaymentGateway?.STAX &&
        isAddNewCard
      ) {
        paymentMethodId = dataPayment?.selectedBank?.cc_token;
      }

      try {
        let params = {
          cluster_id: slug[1],
          state:
            values?.x_state !== ""
              ? values?.x_state
              : userData?.data?.accountData?.state,
          x_method: method,
          phone_number: userData?.data?.accountData?.phone,
          x_amount: amount,
          lead_id: invoiceData?.lead_id,
          custom_conv: paymentMethodId
            ? "on"
            : invoiceData?.custom_conv === "Y"
              ? "on"
              : "off",
          pm_id: paymentMethodId,
        };

        await dispatch(convFeeGet(params)).unwrap();
      } catch (error) {
        console.log("getConvFee error =====", error);
      }
    };
    if (amount > 0) {
      getConvFee();
    }
  }, [amount, selectedMethod, isAddNewCard, dataPayment]);

  const verifyPay = async (paymentMethod: any) => {
    dispatch(setIsPaymentProcessing(true));
    let amt = searchParams.get("amount");
    const isScheduleOnetime = searchParams.get("isScheduleOnetime") === "true";
    let subscription_id = searchParams.get("subscription_id");
    let lead_id = searchParams.get("lead_id");
    let customConv = searchParams.get("custom_conv");
    try {
      let slug = decode(actionId || "")?.split("_");
      let payload = {
        slug: actionId || "",
        lead_id: lead_id,
        cluster_id: slug[1],
        isrecurring: "N",
        x_payment_method: paymentMethod,
        amount: parseFloat(amt as string),
        accountid: accountData?.accountid || "",
        first_name: accountData?.first_name || "",
        last_name: accountData?.last_name || "",
        phone_number: accountData.phone,
        module: "process_payment",
        transaction_id: searchParams.get("payment_intent"),
        isInvoice: true,
        clientInvoiceId: slug[0],
        isScheduleOnetime: isScheduleOnetime,
        schedule_id: subscription_id,
        conv_fee: conFee,
        description: "Online Payment",
        payment_note: "Invoice",
        isPayForProduct: true,
        custom_conv: customConv === "Y" ? "on" : "off",
      };
      let res: any = await dispatch(verifyWalletPay(payload)).unwrap();

      if (res?.body?.success) {
        const { invoice_id } = res?.body?.data;
        setEmail(res?.body?.data?.email);
        setAmountDisplay(res?.body?.data?.total_amount);
        setAmount(res?.body?.data?.amount);

        if (!res?.body?.data?.isDuplicate) {
          let value = {
            invoice_id: slug[0],
            email: accountData?.email,
            order_id: invoice_id,
            clusterid: slug[1],
          };
          let invoiceResult = await updateInvoice(
            value,
            true,
            res?.body?.data?.total_amount
          );
          let pay = {
            invoice_id: res?.body?.data?.invoice_id,
            emails: res?.body?.data?.email,
            invoice_slug: invoiceResult?.invoiceSlug || "",
          };
          await sendEmail(pay);
          changeUrl(invoiceResult);
        }
      } else {
        let value = {
          invoice_id: slug[0],
          email: accountData?.email,
          clusterid: slug[1],
        };
        await updateInvoice(value, false);
        setFailedReason(res?.body?.data?.msg);
      }
      dispatch(setIsPaymentProcessing(false));
    } catch (error) {
      let slug = decode(actionId || "")?.split("_");
      let value = {
        invoice_id: slug[0],
        email: accountData?.email,
        clusterid: slug[1],
      };
      await updateInvoice(value, false);
      console.log("error =====", error);
    } finally {
      dispatch(setIsPaymentProcessing(false));
      setIsScreenLoading(false);
      dispatch(resetDuplicateOrder());
      dispatch(resetCheckDuplicatePayment());
      dispatch(onSetFinalDisclosureLoading(false));
      dispatch(onSetShowDisclosure(false));
    }
  };

  const verifyStaxCardBank = async ({
    cc_token,
    cc_token2,
    x_method,
  }: VerifyStaxCardPaymentParams) => {
    dispatch(setIsPaymentProcessing(true));
    let isScheduleOnetime =
      invoiceData?.subscriptionDetails &&
      Object.keys(invoiceData?.subscriptionDetails)?.length > 0
        ? true
        : false;

    let subscription_id = invoiceData?.subscription_id;

    try {
      let slug = decode(actionId || "")?.split("_");
      let payload = {
        slug: actionId || "",
        cc_token,
        cc_token2,
        lead_id: invoiceData?.lead_id,
        clusterid: slug[1],
        isrecurring: "N",
        x_method: x_method,
        amount: amount,
        accountid: accountData?.accountid || "",
        first_name: accountData?.first_name || "",
        last_name: accountData?.last_name || "",
        phone_number: accountData.phone,
        module: "process_payment",
        isInvoice: true,
        clientInvoiceId: slug[0],
        isScheduleOnetime: isScheduleOnetime,
        schedule_id: subscription_id,
        conv_fee: conFee,
        description: "Online Payment",
        payment_note: "Invoice",
        isPayForProduct: true,
        custom_conv: invoiceData?.custom_conv === "Y" ? "on" : "off",
        email: accountData?.email,
      };
      let res: any = await dispatch(verifyPaymentsViaStax(payload)).unwrap();

      if (res?.body?.success) {
        const { invoice_id } = res?.body?.data;
        setEmail(res?.body?.data?.email);
        setAmountDisplay(res?.body?.data?.total_amount);
        setAmount(
          res?.body?.data?.total_amount ||
            res?.body?.data?.amount ||
            payload?.amount
        );

        if (!res?.body?.data?.isDuplicate) {
          let value = {
            invoice_id: slug[0],
            email: accountData?.email,
            order_id: invoice_id,
            clusterid: slug[1],
          };
          let invoiceResult = await updateInvoice(
            value,
            true,
            res?.body?.data?.total_amount ||
              res?.body?.data?.amount ||
              payload?.amount
          );
          let pay = {
            invoice_id: res?.body?.data?.invoice_id,
            emails: res?.body?.data?.email,
            invoice_slug: invoiceResult?.invoiceSlug || "",
          };
          await sendEmail(pay);
          changeUrl(invoiceResult);
        }
      } else {
        let value = {
          invoice_id: slug[0],
          email: accountData?.email,
          clusterid: slug[1],
        };
        await updateInvoice(value, false);
        setFailedReason(res?.body?.data?.msg);
      }
      dispatch(setIsPaymentProcessing(false));
    } catch (error) {
      let slug = decode(actionId || "")?.split("_");
      let value = {
        invoice_id: slug[0],
        email: accountData?.email,
        clusterid: slug[1],
      };
      await updateInvoice(value, false);
      console.log("error =====", error);
    } finally {
      dispatch(setIsPaymentProcessing(false));
      setIsScreenLoading(false);
      dispatch(resetDuplicateOrder());
      dispatch(resetCheckDuplicatePayment());
      dispatch(onSetFinalDisclosureLoading(false));
      dispatch(onSetShowDisclosure(false));
    }
  };

  const verifyStaxPayPal = async ({
    transactionId,
    error,
  }: {
    transactionId?: string;
    error?: any;
  }) => {
    setIsStaxPayPalLoading(true);
    let isScheduleOnetime =
      invoiceData?.subscriptionDetails &&
      Object.keys(invoiceData?.subscriptionDetails)?.length > 0
        ? true
        : false;

    let subscription_id = invoiceData?.subscription_id;
    setAmountDisplay(amount);
    try {
      let slug = decode(actionId || "")?.split("_");
      let payload = {
        slug: actionId || "",
        transaction_id: transactionId,
        lead_id: invoiceData?.lead_id,
        clusterid: slug[1],
        isrecurring: "N",
        x_method: "PP",
        amount: amount,
        accountid: accountData?.accountid || "",
        first_name: accountData?.first_name || "",
        last_name: accountData?.last_name || "",
        phone_number: accountData.phone,
        module: "process_payment",
        isInvoice: true,
        clientInvoiceId: slug[0],
        isScheduleOnetime: isScheduleOnetime,
        schedule_id: subscription_id,
        conv_fee: conFee,
        description: "Online Payment",
        payment_note: "Invoice",
        isPayForProduct: true,
        custom_conv: invoiceData?.custom_conv === "Y" ? "on" : "off",
        email: accountData?.email,
      };
      let res: any = await dispatch(verifyPaymentsViaStax(payload)).unwrap();

      if (res?.body?.success) {
        const { invoice_id } = res?.body?.data;
        setEmail(res?.body?.data?.email);
        setAmountDisplay(res?.body?.data?.total_amount);
        setAmount(res?.body?.data?.amount);

        if (!res?.body?.data?.isDuplicate) {
          let value = {
            invoice_id: slug[0],
            email: accountData?.email,
            order_id: invoice_id,
            clusterid: slug[1],
          };
          let invoiceResult = await updateInvoice(
            value,
            true,
            res?.body?.data?.total_amount
          );
          let pay = {
            invoice_id: res?.body?.data?.invoice_id,
            emails: res?.body?.data?.email,
            invoice_slug: invoiceResult?.invoiceSlug || "",
          };
          await sendEmail(pay);
          changeUrl(invoiceResult);
        }
      } else {
        let value = {
          invoice_id: slug[0],
          email: accountData?.email,
          clusterid: slug[1],
        };
        await updateInvoice(value, false);
        setFailedReason(res?.body?.data?.msg);
      }
      setIsStaxPayPalLoading(false);
    } catch (error) {
      let slug = decode(actionId || "")?.split("_");
      let value = {
        invoice_id: slug[0],
        email: accountData?.email,
        clusterid: slug[1],
      };
      await updateInvoice(value, false);
      console.log("error =====", error);
    } finally {
      setIsStaxPayPalLoading(false);
      setIsScreenLoading(false);
      dispatch(resetDuplicateOrder());
      dispatch(resetCheckDuplicatePayment());
      dispatch(onSetFinalDisclosureLoading(false));
      dispatch(onSetShowDisclosure(false));
    }
  };

  const handleApprove = async (data: any) => {
    dispatch(setIsPaymentProcessing(true));
    try {
      let payload = {
        slug: actionId || "",
        lead_id: accountLeadData?.lead_id,
        cluster_id: decode(actionId || "")?.split("_")[1],
        balance: userData?.data?.accountData?.balance,
        x_payment_method: "PP",
        cc_token: data?.cc_token,
        cppid: data?.cppid,
        city: userData?.data?.accountData?.city,
        address1: userData?.data?.accountData?.address1,
        address2: userData?.data?.accountData?.address2,
        zipcode: userData?.data?.accountData?.postal_code,
        state: userData?.data?.accountData?.state,
        country: userData?.data?.accountData?.country,
        first_name: userData?.data?.accountData?.first_name,
        last_name: userData?.data?.accountData?.last_name,
        accountid: userData?.data?.accountData?.accountid,
        amount: amount,
        email: userData?.data?.accountData?.email,
        use_old_card: "",
        description: "Online Payment",
        payment_note: "Invoice",
        customer_device: getOperatingSystem(),
        card_type: "",
        old_cardnumber: "",
        old_cvv: "",
        old_expiry: "",
        old_4digit: "",
        old_type: "",
        old_zip: "",
        cvv: "",
        cexpiry: "",
        ccardnumber: "",
        choldername: "",
        aholdername: "",
        routing_number: "",
        account_number: "",
        bank_name: "",
        bank_address: "",
        isInvoice: true,
        clientInvoiceId: payPalOrder?.invoice_id,
        isScheduleOnetime: true,
        schedule_id: payPalOrder?.schedule_id,
        custom_conv:
          invoiceData?.custom_conv === SettingsValue.YES ? "on" : "off",
      };
      let res: any = await dispatch(invoicePayment(payload)).unwrap();
      let slug = decode(actionId || "")?.split("_");
      if (res?.body?.success) {
        setEmail(userData?.data?.accountData?.email);
        setAmountDisplay(data.total_amount);

        let values = {
          invoice_id: payPalOrder?.invoice_id,
          email: accountData?.email,
          order_id: res?.body?.data?.invoice_id,
          clusterid: slug[1],
        };
        let invoiceResult = await updateInvoice(values, true, data.amount);
        let pay = {
          invoice_id: res?.body?.data?.invoice_id,
          emails: res?.body?.data?.email,
          invoice_slug: invoiceResult?.invoiceSlug || "",
        };
        await sendEmail(pay);
        changeUrl(invoiceResult);
      } else {
        let values = {
          invoice_id: payPalOrder?.invoice_id,
          email: accountData?.email,
          order_id: res?.body?.data?.invoice_id,
          clusterid: slug[1],
        };
        await updateInvoice(values, false, data.amount);
      }
      dispatch(setIsPaymentProcessing(false));
    } catch (error) {
      let slug = decode(actionId || "")?.split("_");
      let values = {
        invoice_id: payPalOrder?.invoice_id,
        email: accountData?.email,
        order_id: payPalOrder.orderId,
        clusterid: slug[1],
      };
      await updateInvoice(values, false, data.amount);
      console.log("error =====", error);
    } finally {
      dispatch(setIsPaymentProcessing(false));
      dispatch(resetDuplicateOrder());
      dispatch(resetCheckDuplicatePayment());
      dispatch(onSetFinalDisclosureLoading(false));
      dispatch(onSetShowDisclosure(false));
    }
  };

  useEffect(() => {
    if (searchParams.has("method") && !searchParams.has("checked")) {
      setIsScreenLoading(true);
      searchParams.set("checked", "true");
      if (
        searchParams.get("method") === "cashapp" &&
        searchParams.has("payment_intent")
      ) {
        dispatch(onSetFinalDisclosureLoading(false));
        dispatch(onSetShowDisclosure(false));
        verifyPay("CAPP");
      } else if (
        searchParams.get("method") === "card" &&
        searchParams.has("payment_intent")
      ) {
        dispatch(onSetFinalDisclosureLoading(false));
        dispatch(onSetShowDisclosure(false));
        verifyPay("CC");
      } else if (
        searchParams.get("method") === "bank" &&
        searchParams.has("payment_intent")
      ) {
        dispatch(onSetFinalDisclosureLoading(false));
        dispatch(onSetShowDisclosure(false));
        verifyPay("ACH");
      } else if (
        searchParams.get("method") === "paypal" &&
        (searchParams.has("approval_session_id") ||
          searchParams.has("approval_token_id")) &&
        searchParams.has("status") &&
        searchParams.has("amount")
      ) {
        if (searchParams.get("status") === "success") {
          setIsScreenLoading(true);
          // setInitialDisclosureAccept(true);
          const tokendata = {
            token: payPalOrder?.token,
          };
          dispatch(onSetFinalDisclosureLoading(false));
          dispatch(onSetShowDisclosure(false));
          dispatch(createPaypalPaymentToken(tokendata))
            .unwrap()
            .then((res: any) => {
              if (res?.body?.success) {
                handleApprove(res?.body?.data);
              }
            });
        } else {
          let slug = decode(actionId || "")?.split("_");
          let values = {
            invoice_id: invoiceData?.id,
            email: accountData?.email,
            order_id: payPalOrder.orderId,
            clusterid: slug[1],
          };
          dispatch(onSetFinalDisclosureLoading(false));
          dispatch(onSetShowDisclosure(false));
          updateInvoice(values, false, searchParams.get("amount"));
        }
      } else if (
        searchParams.get("method") === "amazonPay" &&
        searchParams.has("payment_intent")
      ) {
        dispatch(onSetFinalDisclosureLoading(false));
        dispatch(onSetShowDisclosure(false));
        verifyPay("AMZP");
      }

      setTimeout(() => {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
        navigate({ search: "" });
      }, 500);
    }
  }, []);

  const handleApplePay = async (success: boolean, paymentIntent: any) => {
    try {
      let payload = {
        slug: actionId || "",
        lead_id: invoiceData?.lead_id,
        cluster_id: invoiceData?.clusterid,
        isrecurring: "N",
        x_payment_method: "AP",
        amount: amount,
        accountid: accountData?.accountid || "",
        first_name: accountData?.first_name || "",
        last_name: accountData?.last_name || "",
        phone_number: accountData.phone,
        module: "process_payment",
        transaction_id: paymentIntent?.id,
        isInvoice: true,
        clientInvoiceId: invoiceData?.id,
        conv_fee: conFee,
        description: "Online Payment",
        payment_note: "Invoice",
        isPayForProduct: true,
        custom_conv: invoiceData?.custom_conv === "Y" ? "on" : "off",
      };
      let res: any = await dispatch(verifyWalletPay(payload));
      if (res?.payload?.body?.success && success) {
        const { invoice_id } = res?.payload?.body?.data;
        setEmail(res?.payload?.body?.data?.email);
        setAmountDisplay(res?.payload?.body?.data?.total_amount);
        setAmount(res?.payload?.body?.data?.amount);
        let value = {
          invoice_id: invoiceData?.id,
          email: accountData?.email,
          order_id: invoice_id,
          clusterid: invoiceData?.clusterid,
        };
        let invoiceResult = await updateInvoice(value, true, amount);

        let pay = {
          invoice_id: res?.payload?.body?.data?.invoice_id,
          emails: res?.payload?.body?.data?.email,
          invoice_slug: invoiceResult?.invoiceSlug || "",
        };
        await sendEmail(pay);
        changeUrl(invoiceResult);
      } else {
        let value = {
          invoice_id: invoiceData?.id,
          email: accountData?.email,
          clusterid: invoiceData?.clusterid,
        };
        await updateInvoice(value, false, amount);
        setFailedReason(res?.payload?.body?.data?.msg);
      }
      dispatch(setIsPaymentProcessing(false));
    } catch (error: any) {
      let value = {
        invoice_id: invoiceData?.id,
        email: accountData?.email,
        clusterid: invoiceData?.clusterid,
      };
      await updateInvoice(value, false, amount);

      console.log("handleApplePay error =====", error);
    } finally {
      dispatch(setIsPaymentProcessing(false));
      dispatch(resetDuplicateOrder());
      dispatch(resetCheckDuplicatePayment());
      dispatch(onSetFinalDisclosureLoading(false));
      dispatch(onSetShowDisclosure(false));
    }
  };

  const generalMarkers = getGeneralDetailMarkers({
    conFee,
    paymentAmount: amount?.toString(),
    nextDate: moment().format("MM/DD/YYYY"),
  });

  const markIncompleteOrder = async (orderId: number, error: any) => {
    try {
      let slug = decode(actionId || "")?.split("_");
      if (orderId) {
        let res: any = await dispatch(
          markIncompletePayment({
            orderId,
            cluster_id: invoiceData?.clusterid || slug?.[1],
            failed_reason: error.message,
          })
        ).unwrap();
        if (res?.body?.success) {
          setAmountDisplay(res?.body?.data?.amount + res?.body?.data?.cc_fee);
          let pay = {
            invoice_id: res?.body?.data?.invoice_id,
            emails: email || res?.body?.data?.email,
            invoice_slug: invoiceSlug || "",
          };
          await sendEmail(pay);
        }

        let value = {
          invoice_id: slug[0],
          email: accountData?.email,
          clusterid: slug[1],
          order_id: orderId,
        };
        await updateInvoice(value, false);
      }
      setFailedReason(error.message);
    } catch (error) {
      console.log("markIncompleteOrder error ======", error);
    } finally {
      dispatch(resetDuplicateOrder());
      dispatch(resetCheckDuplicatePayment());
      dispatch(onSetShowDisclosure(false));
      dispatch(onSetFinalDisclosureLoading(false));
      dispatch(setIsPaymentProcessing(false));
    }
  };

  const verifyStripeCardPayment = async ({
    intent,
    email,
    error,
    orderId,
    principalAmount,
  }: VerifyStripeCardPaymentParams) => {
    let slug = decode(actionId || "")?.split("_");
    dispatch(setIsPaymentProcessing(true));
    let isScheduleOnetime =
      invoiceData?.subscriptionDetails &&
      Object.keys(invoiceData?.subscriptionDetails)?.length > 0
        ? true
        : false;
    let subscription_id = invoiceData?.subscription_id;

    if (error) {
      await markIncompleteOrder(orderId || 0, error);
    } else {
      try {
        let payload = {
          slug: actionId || "",
          lead_id: invoiceData?.lead_id,
          cluster_id: slug[1],
          isrecurring: "N",
          x_payment_method: "CC",
          amount: principalAmount ?? amount,
          accountid: accountData?.accountid || "",
          first_name: accountData?.first_name || "",
          last_name: accountData?.last_name || "",
          phone_number: accountData.phone,
          module: "process_payment",
          transaction_id: intent,
          email,
          isInvoice: true,
          clientInvoiceId: slug[0],
          isScheduleOnetime: isScheduleOnetime,
          schedule_id: subscription_id,
          conv_fee: conFee,
          description: "Online Payment",
          payment_note: "Invoice",
          isPayForProduct: true,
          incomplete_order_id: orderId,
          custom_conv: invoiceData?.custom_conv === "Y" ? "on" : "off",
        };
        let res: any = await dispatch(verifyWalletPay(payload)).unwrap();
        if (res?.body?.success) {
          const { invoice_id } = res?.body?.data;
          setEmail(email || res?.body?.data?.email);
          setAmountDisplay(res?.body?.data?.total_amount);
          setAmount(res?.body?.data?.amount);

          let value = {
            invoice_id: slug[0],
            email: accountData?.email,
            order_id: invoice_id,
            clusterid: slug[1],
          };
          let invoiceResult = await updateInvoice(
            value,
            true,
            res?.body?.data?.total_amount
          );
          let pay = {
            invoice_id: res?.body?.data?.invoice_id,
            emails: email || res?.body?.data?.email,
            invoice_slug: invoiceResult?.invoiceSlug || "",
          };
          await sendEmail(pay);
          changeUrl(invoiceResult);
        } else {
          let value = {
            invoice_id: slug[0],
            email: accountData?.email,
            clusterid: slug[1],
          };
          await updateInvoice(value, false);
          setFailedReason(res?.body?.data?.msg);
        }
      } catch (error) {
        console.log("verifyStripeCardPayment error =====", error);
        let slug = decode(actionId || "")?.split("_");
        let value = {
          invoice_id: slug[0],
          email: accountData?.email,
          clusterid: slug[1],
        };
        await updateInvoice(value, false);
      } finally {
        dispatch(setIsPaymentProcessing(false));
        dispatch(resetDuplicateOrder());
        dispatch(resetCheckDuplicatePayment());
        dispatch(onSetFinalDisclosureLoading(false));
        dispatch(onSetShowDisclosure(false));
      }
    }
  };

  const handlePlaidBankPayment = async (
    values: any,
    isCCTokenAvailable: boolean = false
  ): Promise<void> => {
    try {
      let payload = {
        ...values,
        x_payment_method: "ACH",
        choldername: values?.choldername,
        default: "N",
      };
      if (isCCTokenAvailable) {
        await handlePayment(payload);
      } else {
        await handleCreateNewCard(payload);
      }
    } catch (error) {
      console.log("handlePlaidBankPayment error =====", error);
    } finally {
      dispatch(setIsPaymentProcessing(false));
    }
  };

  return (
    <div {...testAttrs("page", "Invoice")}>
      <div
        className={`w-full lg:h-[var(--shell-vh)] lg:grid grid-cols-2 lg:overflow-hidden`}
        {...testAttrs("layout", "Invoice payment layout")}
      >
        <div
          style={{ backgroundColor: brandColor }}
          className="relative lg:h-[var(--shell-vh)] w-full"
          {...testAttrs("details-panel", "Invoice details")}
        >
          <div
            className={`classScroll w-full lg:mt-[50px]  mt-[60px]
            lg:h-[calc(var(--shell-vh)-100px)] lg:overflow-y-auto max-h-[calc(var(--shell-vh)-120px)] p-5`}
            {...testAttrs("details-scroll", "Invoice details scroll area")}
          >
            <div className="flex justify-center lg:mt-[7%] h-fit">
              <div
                className={`flex flex-col items-start lg:gap-10 gap-4 w-full lg:max-w-[380px]`}
                {...testAttrs("summary", "Invoice summary")}
              >
                <div className="lg:flex hidden items-center gap-[10px]">
                  {isLoading ? (
                    <Skeleton width={100} height={35} />
                  ) : (
                    <div className="h-16 lg:h-16 flex justify-end">
                      <img
                        src={paymentLogo}
                        alt="Company logo"
                        className="animate__animated animate__fadeIn object-contain"
                      />
                    </div>
                  )}
                </div>
                {/* PAYMENT TYPE AND AMOUNT */}
                <div className={`flex flex-col items-start w-full`}>
                  <span className="w-full flex justify-between items-center">
                    <div
                      className={`${
                        isDark ? "!text-darktxtParagraph" : "!text-txtParagraph"
                      } font-bold lg:text-xl text-lg leading-[26.04px]`}
                    >
                      Invoice
                    </div>
                    <div
                      className={`lg:hidden text-base font-medium underline ${
                        isDark
                          ? "text-darkTxtBlue hover:!text-darkBlueHover"
                          : "text-blue hover:!text-btnPrimaryHover"
                      } cursor-pointer`}
                      role="button"
                      tabIndex={0}
                      {...testAttrs(
                        "toggle-details",
                        showDetails
                          ? "Hide invoice details"
                          : "View invoice details"
                      )}
                      onClick={() => setShowDetails(!showDetails)}
                    >
                      {showDetails ? "Hide details" : "View details"}
                    </div>
                  </span>
                  <div className="flex justify-between w-full lg:mt-4 mt-6 relative">
                    <div className="flex gap-6">
                      <div
                        className={`font-bold lg:leading-[65.1px] leading-[41.66px] ${
                          isDark ? "text-darkTxtPrimary" : "text-txtPrimary"
                        } lg:text-[50px] text-[32px]`}
                      >
                        {formatCurrency(amount)}
                      </div>
                    </div>

                    <div className={`absolute right-0 lg:-top-[26px] -top-2  `}>
                      {!isLoading && (
                        <img
                          src={ORCode || ScannerImg}
                          alt="Invoice QR code"
                          className={`lg:h-[90px] lg:w-[90px] h-[60px] w-[60px]  ${
                            isDark ? "invert" : "mix-blend-multiply"
                          }`}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <span
                  className={`${
                    isDark
                      ? "text-darkTxtBlue hover:!text-darkBlueHover"
                      : "text-blue hover:!text-btnPrimaryHover"
                  } lg:text-xl underline cursor-pointer lg:leading-[26.04px] leading-[20.83px]`}
                  onClick={() => {
                    setIsPreview(true);
                    setId(actionId);
                  }}
                  role="button"
                  tabIndex={0}
                  {...testAttrs(
                    "view-invoice-details",
                    "View invoice and payment details"
                  )}
                >
                  View invoice and payment details
                </span>
                <span
                  className={`drawer ${
                    showDetails && "open"
                  } flex flex-col w-full gap-5`}
                  {...testAttrs("account-details", "Invoice account details")}
                >
                  {/* LINE */}
                  <div className="h-[1px] bg-strokeActive lg:w-[380px] w-full" />
                  {/* ACCOUNT DETAILS */}
                  <div className="flex flex-col gap-4 w-full">
                    <div className="flex flex-col gap-3 lg:max-w-[380px] w-full">
                      <div className="flex justify-between items-center">
                        <div
                          className={`leading-[26.04px] ${
                            isDark
                              ? "text-darkTxtBlue"
                              : "text-blue hover:!text-btnPrimaryHover"
                          } font-medium text-xl`}
                        >
                          {isLoading ? (
                            <Skeleton width={150} />
                          ) : (
                            (userData?.data?.accountData?.first_name || "") +
                            " " +
                            (userData?.data?.accountData?.last_name || "")
                          )}
                        </div>
                        <div
                          className={`text-sm ${
                            isDark ? "text-darkTxtPrimary" : "text-txtPrimary"
                          }`}
                        >
                          {isLoading ? (
                            <Skeleton width={80} />
                          ) : (
                            userData?.data?.accountData?.accountid
                          )}
                        </div>
                      </div>
                      <div className="flex flex-col items-start gap-1">
                        <div className="grid grid-cols-2 w-full">
                          <div
                            className={`leading-[20px] ${
                              isDark
                                ? "text-darkTxtSecondary"
                                : "text-txtSecondary"
                            } text-sm text-left`}
                          >
                            Balance
                          </div>
                          <div
                            className={`leading-[20px] ${
                              isDark
                                ? "text-darkTxtSecondary"
                                : "text-txtSecondary"
                            } text-sm text-right`}
                          >
                            Description
                          </div>
                        </div>
                        <div className="grid grid-cols-2 w-full">
                          <div
                            className={`leading-[20px] ${
                              isDark ? "text-darkTxtPrimary" : "text-txtPrimary"
                            } text-sm text-left`}
                          >
                            {isLoading ? (
                              <Skeleton width={70} />
                            ) : (
                              <>
                                {formatCurrency(
                                  userData?.data?.accountData?.balance
                                ) || "$0.00"}
                              </>
                            )}
                          </div>
                          <div
                            className={`leading-[20px] ${
                              isDark ? "text-darkTxtPrimary" : "text-txtPrimary"
                            } text-sm text-right`}
                          >
                            {isLoading ? (
                              <Skeleton width={80} />
                            ) : (
                              (userData?.data?.accountData?.description ?? "--")
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* LINE */}
                    <div className="h-[1px] bg-strokeActive lg:w-[380px] w-full" />
                    <div className="flex flex-col gap-3 lg:max-w-[380px] w-full">
                      <div className="flex flex-col items-start gap-1">
                        <div className="flex justify-between items-center w-full">
                          <div
                            className={`leading-[16px] ${
                              isDark
                                ? "text-darkTxtSecondary"
                                : "text-txtSecondary"
                            } text-[10px] uppercase text-left`}
                          >
                            Invoice Number
                          </div>
                          <div
                            className={`leading-[16px] ${
                              isDark
                                ? "text-darkTxtSecondary"
                                : "text-txtSecondary"
                            } text-[10px] uppercase text-right`}
                          >
                            Due Date
                          </div>
                        </div>
                        <div className="flex justify-between items-center w-full">
                          <div
                            className={`leading-[20px] ${
                              isDark ? "text-darkTxtPrimary" : "text-txtPrimary"
                            } text-sm text-left`}
                          >
                            {isLoading ? (
                              <Skeleton width={70} />
                            ) : (
                              <>#{invoiceData?.invoice_number}</>
                            )}
                          </div>
                          <div
                            className={`leading-[20px] ${
                              isDark ? "text-darkTxtPrimary" : "text-txtPrimary"
                            } text-sm text-right`}
                          >
                            {isLoading ? (
                              <Skeleton width={70} />
                            ) : (
                              <>
                                {invoiceData?.due_date
                                  ? moment(invoiceData?.due_date).format(
                                      "MM/DD/YYYY"
                                    )
                                  : ""}
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
                <Footer
                  style={{ backgroundColor: brandColor }}
                  className={`lg:!flex !hidden !w-[30%] max-w-[380px] !justify-start  ${
                    isDark ? "!text-darktxtParagraph" : "!text-txtParagraph"
                  }`}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          ref={stepperAnchorRef}
          className="h-0 lg:hidden block"
          style={{ scrollMarginTop: "84px" }}
          data-testid="invoice-payment-stepper-anchor"
        />

        <div
          className={`w-full lg:h-[var(--shell-vh)] lg:overflow-y-auto ${
            showFinalDisclosure ? "hidden none" : ""
          }`}
          {...testAttrs("payment-section", "Invoice payment section")}
        >
          {isScreenLoading || isLoading ? (
            <div
              className="w-full h-full flex justify-center items-center"
              {...testAttrs("loading", "Loading invoice")}
            >
              <div className="h-10 w-10 animate-spin rounded-full border-2 border-solid border-blue border-r-transparent align-[-0.125em] text-primary motion-reduce:animate-[spin_1.5s_linear_infinite]"></div>
            </div>
          ) : (
            <div
              className={`text-xl font-medium w-full ${
                paymentSuccess ? "" : "lg:pt-[100px] "
              } min-h-full`}
            >
              {!paymentSuccess ? (
                portalSettings?.state_disclosure_flag === SettingsValue.OFF ||
                initialDisclosureAccept ? (
                  <div
                    className={`grid place-items-center px-5 mt-2 h-full w-full`}
                    {...testAttrs(
                      "payment-methods-region",
                      "Invoice payment methods"
                    )}
                  >
                    <div className=" flex flex-col max-w-[510px] w-full lg:gap-10 gap-5  h-full text-LightTextParagraph ">
                      {isAddNewCard ? (
                        <>
                          <div>
                            <div className="flex justify-between items-center lg:pb-10 pb-5">
                              <p className="lg:text-xl text-lg font-medium">
                                Payment method
                              </p>

                              <p
                                onClick={() => {
                                  dispatch(setIsPaymentProcessing(true));
                                  setIsAddNewCard(false);
                                }}
                                className="flex gap-2 items-center cursor-pointer xl:text-sm text-xs  font-medium text-blue hover:!text-btnPrimaryHover"
                                role="button"
                                tabIndex={0}
                                {...testAttrs(
                                  "add-new-payment-method",
                                  "Add new payment method"
                                )}
                              >
                                <AddCircleIconBlue aria-hidden="true" /> Add New
                              </p>
                            </div>

                            <PaymentProcessStep2
                              data={dataPayment}
                              setData={setDataPayment}
                              setCurrentStep={() => {}}
                              isDataLoading={isLoading}
                              currentStep={2}
                              walletList={oldWalletData}
                              setSavedCardsEmail={setSavedCardsEmail}
                              isPaymentLink={true}
                              paymentMethodList={paymentMethodList}
                              setSelectedMethod={setSelectedMethod}
                              custom_conv={
                                invoiceData?.custom_conv === "Y" ? "on" : "off"
                              }
                            />
                          </div>
                        </>
                      ) : (
                        <PaymentMethodsComponent
                          cardData={{
                            cardNumber,
                            isDateErr,
                            isErr,
                            cardErrMsg,
                            handleChangeCard,
                            validateCard: () =>
                              validateCard({
                                values,
                                iconType,
                                setIsErr,
                                setCardErrMsg,
                                setErrMsg,
                              }),
                            iconType,
                            setIsAddNewCardMakePayment: setIsAddNewCard,
                            isAddNewCardMakePayment: isAddNewCard,
                            setIconType,
                            showNewStripeCardForm: true,
                          }}
                          bankData={{
                            bankName,
                            numberNotmatchedError,
                            setnumberNotmatchedError,
                            handleChangeBank,
                            selectedState,
                            setSelectedState,
                            stripeBankURL: `${window.location.href}?method=bank&custom_conv=${invoiceData?.custom_conv}&amount=${amount}&lead_id=${
                              invoiceData?.lead_id
                            }&subscription_id=${
                              invoiceData?.subscription_id
                            }&isScheduleOnetime=${
                              invoiceData?.subscriptionDetails &&
                              Object.keys(invoiceData?.subscriptionDetails)
                                ?.length > 0
                                ? true
                                : false
                            }`,
                            handlePlaidBankPayment,
                            isManualForm,
                            setIsManualForm,
                          }}
                          paymentConfig={{
                            paymentMethodList,
                            selectedMethod,
                            setSelectedMethod,
                            amount,
                            isPaymentLink: true,
                            isInvoice: true,
                            custom_conv:
                              invoiceData?.custom_conv === "Y" ? "on" : "off",
                            isStaxPayPalLoading,
                          }}
                          paymentHandlers={{
                            handleGooglePay: (tokenData: any, amount: any) => {
                              handleGooglePayPayment(tokenData, amount);
                            },
                            createPayPalIntent,
                            handleApplePay,
                            verifyStripeCardPayment,
                            verifyStaxCardBank,
                            verifyStaxPayPal,
                          }}
                          paymentUrls={{
                            cashAppURL: `${window.location.href}?method=cashapp&custom_conv=${invoiceData?.custom_conv}&amount=${amount}&lead_id=${
                              invoiceData?.lead_id
                            }&subscription_id=${
                              invoiceData?.subscription_id
                            }&isScheduleOnetime=${
                              invoiceData?.subscriptionDetails &&
                              Object.keys(invoiceData?.subscriptionDetails)
                                ?.length > 0
                                ? true
                                : false
                            }`,
                            stripeAmazonPayURL: `${
                              window.location.href
                            }?method=amazonPay&custom_conv=${invoiceData?.custom_conv}&amount=${amount}&lead_id=${
                              invoiceData?.lead_id
                            }&subscription_id=${
                              invoiceData?.subscription_id
                            }&isScheduleOnetime=${
                              invoiceData?.subscriptionDetails &&
                              Object.keys(invoiceData?.subscriptionDetails)
                                ?.length > 0
                                ? true
                                : false
                            }`,
                          }}
                          formState={{
                            values,
                            email,
                            setEmail,
                            errMsg,
                            isRingLoading,
                          }}
                          paymentGatewayState={{
                            isGoogleLoading,
                          }}
                          componentRefs={{
                            cashAppRef,
                            bankRef,
                            cardRef,
                            amazonRef,
                          }}
                          phoneAndAddressConfig={{}}
                          description={"Invoice"}
                          accounts_id={invoiceData?.accounts_id}
                          noAuthClusterId={invoiceData?.clusterid}
                        />
                      )}
                      <div className="w-full pb-9 ">
                        {showButtons && (
                          <>
                            <Button
                              text={`Pay ${
                                formatCurrency(amount + conFee) || "$0.00"
                              }`}
                              className={`w-full`}
                              isDisabled={
                                isDisabled ||
                                numberNotmatchedError ||
                                (selectedMethod === "Bank" && isRingLoading) ||
                                isFeeLoading
                              }
                              isLoading={isBTNLoading}
                              {...testAttrs("pay-invoice", "Pay invoice")}
                              onClick={() => {
                                handleSubmit();
                              }}
                              variant="variable"
                            />
                          </>
                        )}
                      </div>
                    </div>{" "}
                  </div>
                ) : (
                  <div
                    className="xl:px-20 lg:px-10 px-5 lg:pt-0 pt-5 lg:h-full w-full"
                    {...testAttrs(
                      "initial-disclosure",
                      "Initial invoice disclosure"
                    )}
                  >
                    <DisclosureInitial
                      isOpen={true}
                      handleAccept={() => setInitialDisclosureAccept(true)}
                      generalMarkers={generalMarkers}
                    />
                  </div>
                )
              ) : paymentSuccess === "success" ? (
                isWirePayment ? (
                  <div
                    className="w-full h-full grid place-items-center"
                    {...testAttrs(
                      "wire-success",
                      "Invoice wire payment success"
                    )}
                  >
                    <WirePaymentSuccess
                      bankDetails={wireDetails}
                      orderId={id}
                      isRetry={true}
                      lead_id={invoiceData?.lead_id}
                      sendEmail={sendEmail}
                    />
                  </div>
                ) : (
                  <div
                    className="w-full h-full grid place-items-center"
                    {...testAttrs("success", "Invoice paid successfully")}
                  >
                    <InvoiceSuccess
                      className=""
                      amount={amountDisplay}
                      emailInput={emailInput}
                      setEmailInput={setEmailInput}
                      invoiceId={actionId}
                      setId={setId}
                      setIsPreview={setIsPreview}
                      isEmailLoading={isEmailLoading}
                      handleSendEmail={sendEmail}
                      isDownloadLoading={isDownloadLoading}
                      handleDownloadPDF={handleDownloadPDF}
                      orderId={orderId}
                    />
                  </div>
                )
              ) : paymentSuccess === "cancelled" ? (
                <InvoiceCanceled />
              ) : (
                <InvoiceFail
                  handleBackToStart={handleBackToStart}
                  failedReason={failedReason}
                />
              )}
            </div>
          )}
        </div>
        <div
          className={`w-full lg:h-[var(--shell-vh)] lg:overflow-y-auto relative content lg:pt-20 lg:pb-[40px] lg:px-10 md:p-10 p-5 max-w-[740px] mx-auto ${
            !showFinalDisclosure ? "hidden none" : ""
          }`}
          {...testAttrs("final-disclosure", "Final invoice disclosure")}
        >
          <DisclosureFinal
            generalMarkers={generalMarkers}
            handleAccept={handleAccept}
            isOpen={showFinalDisclosure}
          />
        </div>
      </div>
      <Drawer
        enableOverlay={true}
        lockBackgroundScroll={true}
        direction="right"
        open={isPreview}
        size={isLessThan590 ? `100vw` : "590px"}
        onClose={() => {
          setIsPreview(false);
          setId("");
        }}
        overlayColor="#000"
      >
        <div className="contents" {...testAttrs("invoice-preview-drawer")}>
          <InvoicePreview
            id={id}
            slug={id}
            setId={setId}
            setIsPreview={setIsPreview}
            isPreview={isPreview}
            isSlug={true}
            showAccountDetails={false}
          />
        </div>
      </Drawer>

      <CustomModal
        signModal={false}
        isLoading={false}
        isOpen={showModal}
        title="Alert"
        className="max-w-[600px] w-full h-fit rounded-[10px]"
        doneText="Leave"
        cancleText="Stay"
        onDoneClick={handleConfirmLeave}
        onCloseClick={handleCancelLeave}
        children={
          <React.Fragment>
            <div
              className="pt-5 lg:text-xl text-txtPrimary lg:leading-[30px] leading-[24px]"
              {...testAttrs("leave-page-alert")}
            >
              Are you sure you want to leave the page? All progress will be
              lost.
            </div>
          </React.Fragment>
        }
      />

      <CustomModal
        signModal={false}
        isLoading={false}
        isOpen={isDuplicateOrders && duplicateOrdersCount > 0}
        title="Alert"
        doneText="Complete Payment"
        className="max-w-[600px] w-full h-fit rounded-[10px]"
        cancleText="Cancel"
        onDoneClick={() => {
          dispatch(resetDuplicateOrder());
          handleAccept();
        }}
        onCloseClick={() => {
          dispatch(resetCheckDuplicatePayment());
          dispatch(resetDuplicateOrder());
        }}
        children={
          <React.Fragment>
            <div
              className="pt-5 lg:text-xl text-txtPrimary lg:leading-[30px] leading-[24px]"
              {...testAttrs("duplicate-payment-alert")}
            >
              A similar payment was made in the last 10 minutes. Click 'Complete
              Payment' if this is not a duplicate.
            </div>
          </React.Fragment>
        }
      />
    </div>
  );
};

const Invoice = () => (
  <TestIdScope scope="invoice">
    <InvoiceContent />
  </TestIdScope>
);

export default Invoice;
